import Dashboard from 'CustomModules/SelfService/pages/Dashboard/Dashboard'
import Atributos from 'CustomModules/SelfService/pages/Dashboard/Atributos'
import Beneficios from 'CustomModules/SelfService/pages/Dashboard/Beneficios'

export const Routes = [
  {
    path: '/',
    name: 'Self Service Dashboard',
    component: Dashboard
  },
  {
    path: 'atributos_ss',
    name: 'Atribuntos',
    component: Atributos
  }
]

// Global routes
export const GlobalRoutes = [
  {
    path: '/beneficios_ss',
    name: 'Beneficios',
    component: Beneficios
  }
]



// WEBPACK FOOTER //
// ./src/customization/SelfService/routes.js